import { z } from 'zod';

export const SubscriptionSchema = z.object({
  id: z.string(),
  name: z.string(),
  tier: z.string(),
  status: z.string(),
  note: z.string(),
  validity: z.string(),
  startDate: z.string(),
  endDate: z.string(),
  icon: z.string(),
});

export type Subscription = z.infer<typeof SubscriptionSchema>;
